// MobileNav — 1:1 port of legacy src/shell/MobileNav.jsx.
// Hamburger-triggered drawer that wraps the expanded Sidebar at narrow widths.
// The responsive `useNarrow` hook now lives in apps/web/src/ui/useNarrow.ts.
import { useEffect } from 'react';
import { Sidebar } from './Sidebar.js';

export interface MobileNavProps {
  open: boolean;
  onClose: () => void;
}

export function MobileNav({ open, onClose }: MobileNavProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    // Backdrop: click dismisses. Escape-to-close is bound above.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 70,
        background: 'var(--scrim)',
        display: 'flex',
      }}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 280,
          height: '100%',
          background: 'var(--sidebar-bg)',
          borderRight: '1px solid var(--sidebar-border)',
        }}
      >
        <Sidebar forceExpanded onToggleOverride={onClose} onNavigate={onClose} />
      </div>
    </div>
  );
}
